export default __webpack_public_path__ + "static/media/beneficios-cadastro-alertas.54adb4a4.png";